export default __webpack_public_path__ + "static/media/GreenUp.6035249c.svg";